import { createRouter, createWebHistory } from "vue-router";
import EventList from "../views/EventList.vue";
import About from "../views/About.vue";
import EventDetails from "../views/event/Details.vue";
import EventEdit from "../views/event/Edit.vue";
import EventRegister from "../views/event/Register.vue";
import EventLayout from "../views/event/Layout.vue";
import NotFound from "../views/NotFound.vue";
import NetworkError from "../views/NetworkError.vue";
const routes = [
  {
    path:"/:catchAll(.*)",
    name: "NotFound",
    component: NotFound
  },
  {
    path:"/404/:resource",
    name: "404Resource",
    props: true,
    component: NotFound
  },
  {
    path: "/",
    name: "EventList",
    component: EventList,
    props: (route) => ({
      //perPage: parseInt(route.query._limit), 
      page: parseInt(route.query.page) || 1
    })
  },
  {
    path: '/network-error',
    name: 'NetworkError',
    component: NetworkError
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/events/:id",
    name: "EventLayout",
    props: true,
    component: EventLayout,
    children: [
      {
      path: '',
      name: 'EventDetails',
      component: EventDetails
      },
      {
        path: "register",
        name: "EventRegister",

        component: EventRegister,
      },
      {
        path: "edit",
        name: "EventEdit",
        component: EventEdit,
      }
    ]
  }, 
  {
    path: '/event/:afterEvent(.*)',
    redirect: to => {
      return { path: '/events/' + to.params.afterEvent}
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
